var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuppet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFA61A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.225902 0 0 -1.225902 -36.503286 963.24965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.9,754.9H84.3v-11.7h11.7L95.9,754.9z M77.7,733h-3.6v3.6h3.6L77.7,733z M82.1,741H69.7v-12.4h12.4V741z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.5,751.9l-7.4,7.4l2.8,2.8l7.4-7.4L84.5,751.9z M82,738.2l-2.8,2.8l5.8,5.8l2.8-2.8L82,738.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,761.4h-3.6v3.6h3.6L77.7,761.4z M82.1,769.4H69.7v-12.4h12.4V769.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppet);
export default __webpack_public_path__ + "static/media/Puppet.a783cbc400d722069593e2447af0d92d.svg";
export { ForwardRef as ReactComponent };